import { useContext } from 'react';

import { AppContext } from '../context/AppContext';

const noop = (...args: any) => {};

const mock: AppContext = {
  showToast: noop,
  hideToast: noop,
  startLoading: noop,
  stopLoading: noop,
  isSSR: false,
};

// TODO: Remove and use notNullableContext as they are doing the same thing
export const useApp = () => {
  const context = useContext(AppContext);

  if (!context) {
    console.warn('No AppContext has been set');

    return mock;
  }

  return context;
};
